/* eslint-disable no-shadow */
/* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
/* eslint-disable react/jsx-props-no-spreading */
import queryString from "query-string";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import { Button as MuiButton } from "@mui/material";
import { Helmet } from "react-helmet";
import ExportButton from "./Components/ExportButton";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import AppliedFilter from "../../../components/common/AppliedFilter/AppliedFilter";
import Loader from "../../../components/common/Loader/Loader";
import Modal from "../../../components/common/Modal/Modal";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import useUserConfig from "../../../hooks/useUserConfig";
import {
  AppliedFilterLabelMap,
  DATES,
  EVENT_NAME,
  Constants,
  AlertStatus,
} from "../../../contants";
import useQueryParams from "../../../hooks/useQueryParams";
import { SET_SELECTED_MEMBER_TRANSFER } from "../../../redux/actionTypes/dashboard";
import {
  selectAllSIUsers,
  selectOSKeysByUserRole,
} from "../../../redux/selectors/user";
import { ROUTES } from "../../../utils/constants";
import { formDataToObject, isEmptyObj } from "../../../utils/helper";
import styles from "./styles";
import MemberTable from "./Components/Table";
import OrganizationSearch from "./OrganizationSearch";
import PersonalDetailsSearch from "./PersonalDetailSearch";
import {
  getFilters,
  getFormattedQuery,
  getRoutePath,
  handleDependencyFilter,
  performOperation,
} from "./utils";
import Examination from "../../../services/api/examination";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import Toast from "../../../components/common/Toast";

const LOADER_DELAY = 1000;
const PAGE = "page";
const filterOrder = ["areaId", "zoneId", "regionId", "chapterId", "districtId"];

const intialPaginationState = {
  currentPage: 0,
  totalPages: 0,
  totalElements: 0,
  pageSize: Constants.DEFAULT_PAGE_SIZE,
};

function ExaminationMemberSearch() {
  const TITLE = "Examination Member Search - BSG";
  const [searchData, setSearchData] = useState([]);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState(intialPaginationState);
  const [isLoading, setIsLoading] = useState(false);
  const [openResultModal, setOpenResultModal] = useState(false);
  const allowModalRef = useRef(false);
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );

  const formRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const metaData = useSelector((state) => state.meta);
  const disabledOSKeys = useSelector(selectOSKeysByUserRole);
  const { isHelpDesk, isChapterSi, isHelpDeskAdmin, isAreaSi, isZoneSi } =
    useSelector(selectAllSIUsers);
  const hasPermission = useUserConfig();
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const [examLevel, setExamLevel] = useState(); // ✅ Original: undefined
  const toast = useContext(ToastAlertContext);
  const [showToast, setShowToast] = useState(null);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const updatePaginationInfo = (pagination) => {
    setPaginationInfo({
      currentPage: pagination.number,
      totalPages: pagination.totalPages,
      totalElements: pagination.totalElements,
      pageSize: pagination.size,
    });
  };

  const clearFormRef = () => {
    Object.keys(AppliedFilterLabelMap).forEach((key) => {
      if (formRef.current[key]) {
        formRef.current[key].value = "";
        formRef.current[key]?.blur();
      }
    });
  };

  const resetFormState = () => {
    setSearchData([]);
    setAppliedFilters([]);
    setPaginationInfo(intialPaginationState);
    clearFormRef();
    // ✅ Don't reset examLevel - keep original behavior
  };

  const initializeFormState = (queryObject) => {
    if (!isEmptyObj(queryObject)) {
      clearFormRef();
      Object.keys(queryObject).forEach((key) => {
        if (formRef.current[key]) {
          formRef.current[key].value = queryObject[key];
        }
      });
      // ✅ Original logic - no examLevel init here
    }
  };

  const updateSearchParam = (query) => {
    if (query?.length) {
      navigate(`${getRoutePath()}?${query}`);
    } else {
      navigate(`${getRoutePath()}`);
    }
  };

  const removeKeyFromQuery = (queryObject, filterKey) => {
    let updatedQuery = { ...queryObject, page: 0 };

    if (DATES.includes(filterKey)) {
      delete updatedQuery[filterKey];
      delete updatedQuery[`${filterKey.split("From")[0]}To`];
    } else {
      delete updatedQuery[filterKey];
    }

    if (Object.keys(updatedQuery).length === 1 && PAGE in updatedQuery) {
      delete updatedQuery[PAGE];
    }

    if (disabledOSKeys && Array.isArray(disabledOSKeys)) {
      updatedQuery = handleDependencyFilter(updatedQuery, disabledOSKeys);
    }

    return updatedQuery;
  };

  const onRemoveFilter = (filterKey) => {
    setPaginationInfo(intialPaginationState);
    let queryObject = getQueryObject();
    queryObject = removeKeyFromQuery(queryObject, filterKey);
    const updatedQuery = queryString.stringify(queryObject);
    updateSearchParam(updatedQuery);
  };

  const hasAnyRealFilter = (q) => {
    if (!q || isEmptyObj(q)) return false;
    return Object.entries(q).some(
      ([k, v]) =>
        !["page", "pageSize"].includes(k) &&
        v !== undefined &&
        String(v).trim() !== ""
    );
  };

  const validateAndFetchData = (formattedQuery, toastCtx, setLoading) => {
    if (
      !formattedQuery.hasOwnProperty("examLevel") ||
      formattedQuery.examLevel === ""
    ) {
      toastCtx.show("Please select exam level", AlertStatus.ERROR);
      setLoading(false);
      return false;
    }

    return true;
  };

  const fetchSearchData = async (queryParams, params = {}) => {
    try {
      setIsLoading(true);
      const formattedQuery = getFormattedQuery(queryParams);

      if (validateAndFetchData(formattedQuery, toast, setIsLoading)) {
        const { data } = await Examination.MemberSearch(formattedQuery, params);

        setTimeout(() => {
          setSearchData(data.content);
          updatePaginationInfo(data);
          setIsLoading(false);

          if (data.content?.length > 0) {
            if (allowModalRef.current) {
              setOpenResultModal(true);
              allowModalRef.current = false;
            }
          } else {
            setShowToast({
              severity: "error",
              message: "No data found",
            });
            setOpenResultModal(false);
            allowModalRef.current = false;
          }
        }, LOADER_DELAY);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        error.message || "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
      Sentry.captureException(error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setPaginationInfo(intialPaginationState);

    const rawFormData = new FormData(formRef.current);
    const formData = formDataToObject(rawFormData);
    formData.examLevel = examLevel; // ✅ Original logic

    const hasFilter = Object.values(formData).some(
      (val) => val && String(val).trim() !== ""
    );
    if (!hasFilter) {
      setShowToast({
        severity: "warning",
        message: "Please select your search filter",
      });
      return;
    }

    const query = queryString.stringify(formData);

    document.dispatchEvent(new Event(EVENT_NAME));

    allowModalRef.current = true;

    updateSearchParam(query);
  };

  useEffect(() => {
    const queryObject = getQueryObject();

    if (isEmptyObj(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      return;
    }

    if (!hasAnyRealFilter(queryObject)) {
      resetFormState();
      setOpenResultModal(false);
      allowModalRef.current = false;
      if (
        queryObject.page !== undefined ||
        queryObject.pageSize !== undefined
      ) {
        updateSearchParam();
      }
      return;
    }

    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
    initializeFormState(query);
  }, [urlSearchParams.toString()]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (
      !isEmptyObj(queryObject) &&
      metaData &&
      disabledOSKeys &&
      Array.isArray(disabledOSKeys) &&
      hasAnyRealFilter(queryObject)
    ) {
      const query = getQueryParams(queryObject)[0];
      try {
        setAppliedFilters(getFilters(query, metaData, disabledOSKeys));
      } catch (err) {
        console.error("Error in getFilters:", err);
        setAppliedFilters([]);
      }
    } else {
      setAppliedFilters([]);
    }
  }, [metaData, disabledOSKeys, urlSearchParams.toString()]);

  const onPaginationClick = (clickedNumber) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: clickedNumber,
    });
    updateSearchParam(queryParams);
  };

  const onPageSizeClick = (operator) => {
    const queryObject = getQueryObject();
    const queryParams = queryString.stringify({
      ...queryObject,
      page: 0,
      pageSize: queryObject.pageSize
        ? performOperation(
            queryObject.pageSize,
            Constants.DEFAULT_PAGE_SIZE,
            operator
          )
        : 2 * Constants.DEFAULT_PAGE_SIZE,
    });
    updateSearchParam(queryParams);
  };

  const onSelectMemberForTransfer = (member) => {
    dispatch({
      type: SET_SELECTED_MEMBER_TRANSFER,
      payload: member,
    });
    navigate(ROUTES.MEMBER_TRANSFER_REQUEST.path);
  };

  const onSelectMember = (member) => {
    navigate(`/${ROUTES.MEMBER_DETAIL.path}/${member.memberId}`);
  };

  const onRefresh = () => {
    const queryObject = getQueryObject();
    const [query, params] = getQueryParams(queryObject);
    fetchSearchData(query, params);
  };

  const handleGoBackToSearch = () => {
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const handleResetAndClose = () => {
    resetFormState();
    updateSearchParam();
    setOpenResultModal(false);
    allowModalRef.current = false;
  };

  const orderedFilters = filterOrder
    .map((filterKey) =>
      appliedFilters.find((filter) => filter.key === filterKey)
    )
    .filter(Boolean);

  const additionalFilters = appliedFilters.filter(
    (filter) => !filterOrder.includes(filter.key)
  );

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div style={styles.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1px",
          }}
        >
          <MuiButton
            onClick={handleResetAndClose}
            variant="outlined"
            color="secondary"
            sx={{
              textTransform: "none",
              height: "20px",
              fontSize: "13px",
              fontWeight: "600",
              marginRight: "10px",
              width: "85px",
              padding: "0px !important",
            }}
          >
            Clear Filters
          </MuiButton>
        </div>

        {/* Search Form */}
        <div style={styles.filter}>
          <form
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "100%",
            }}
            onSubmit={onSubmit}
            ref={formRef}
          >
            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Organization Structure
              </div>
              <OrganizationSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
              />
            </div>

            <div>
              <div style={{ fontWeight: "600", marginBottom: "8px" }}>
                Personal Details
              </div>
              <PersonalDetailsSearch
                formRef={formRef}
                disabledOSKeys={disabledOSKeys}
                examLevel={examLevel}
                setExamLevel={setExamLevel}
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: isMobile ? "center" : "flex-end",
                paddingTop: isMobile ? "20px" : "10px",
                marginRight: isMobile ? "15px" : "10px",
                paddingBottom: isMobile ? "100px" : "0px",
              }}
            >
              <MuiButton
                type="submit"
                variant="contained"
                color="primary"
                sx={{
                  width: isMobile ? "90%" : "auto",
                }}
              >
                Search
              </MuiButton>
            </div>
          </form>
        </div>
        {/* Mobile separator border - visual boundary */}
        {isMobile && (
          <div
            style={{
              borderTop: "2px solid #ffffffff",
              paddingTop: "15px",
              paddingBottom: "30px",
              marginTop: "10px",
            }}
          />
        )}

        {isLoading && <Loader />}

        {/* Search Results Modal */}
        <Modal
          open={openResultModal}
          onClose={handleGoBackToSearch}
          title="Search Results"
          customStyle={{
            marginTop: "30px",
            width: "98%",
            maxWidth: "100%",
            height: "90%",
            maxHeight: "100%",
            overflowY: "auto",
            backgroundColor: "#fff",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            position: "relative",
          }}
        >
          {isLoading ? (
            <Loader />
          ) : searchData.length > 0 ? (
            <>
              {/* Header Row */}
              <div
                style={{
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: "10px",
                  fontWeight: 600,
                  fontSize: 13,
                  marginBottom: "0px",
                  paddingBottom: "0px",
                  borderBottom: "1px solid #eee",
                }}
              >
                {/* Left: Total + Filters */}
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    minWidth: 260,
                    gap: 10,
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "0 0 auto" }}>
                    Total Members: {paginationInfo.totalElements}
                  </div>
                  {appliedFilters.length > 0 && (
                    <div style={{ flex: 1, minWidth: 200 }}>
                      <div style={styles.filterWrapper}>
                        <div style={styles.filterContainer}>
                          {orderedFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                          {additionalFilters.map((filter) => (
                            <AppliedFilter
                              key={filter.key}
                              filter={filter}
                              onRemove={onRemoveFilter}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Right: Export + Reload + Back + Clear */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    flexWrap: "wrap",
                    flex: "0 0 auto",
                  }}
                >
                  <ExportButton
                    data={searchData}
                    exportFunction={Examination.eligibleMemberReport}
                  />
                  <div style={styles.reload} onClick={onRefresh}>
                    <ReloadIcon />
                  </div>
                  <MuiButton
                    onClick={handleResetAndClose}
                    variant="outlined"
                    color="secondary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                      minWidth: "100px",
                    }}
                  >
                    Clear Filters
                  </MuiButton>
                  <MuiButton
                    onClick={handleGoBackToSearch}
                    variant="contained"
                    color="primary"
                    sx={{
                      textTransform: "none",
                      height: "32px",
                      fontSize: "13px",
                      padding: "0 14px",
                    }}
                  >
                    Back
                  </MuiButton>
                </div>
              </div>

              {/* Table */}
              <div style={{ flex: 1, overflowX: "auto", marginTop: "15px" }}>
                <MemberTable
                  searchData={searchData}
                  onSelectMemberForTransfer={onSelectMemberForTransfer}
                  onSelectMember={onSelectMember}
                  hasPermission={hasPermission}
                  showStatusColumn={isHelpDesk || isHelpDeskAdmin}
                  isChapterSi={isChapterSi}
                  isHelpDesk={isHelpDesk}
                  isAreaSi={isAreaSi}
                  isZoneSi={isZoneSi}
                  isHelpDeskAdmin={isHelpDeskAdmin}
                />
              </div>

              {/* Pagination */}
              {searchData.length > 0 && (
                <div style={{ marginTop: "20px" }}>
                  <Pagination
                    totalPages={paginationInfo.totalPages}
                    totalResults={paginationInfo.totalElements}
                    currentPage={paginationInfo.currentPage}
                    pageSize={paginationInfo.pageSize}
                    onChange={onPaginationClick}
                    onPageSizeClick={onPageSizeClick}
                  />
                </div>
              )}
            </>
          ) : null}
        </Modal>

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => setShowToast(null)}
        />
      </div>
    </>
  );
}

export default ExaminationMemberSearch;
